package entities

import kotlinx.serialization.Serializable

@Serializable
data class Ad(
    val id: Int,
    val name: String,
    val message: String
)